module.exports = __webpack_public_path__ + "static/media/14.1cce90f4.png";